// extracted by mini-css-extract-plugin
module.exports = {"avalia-black":"#000c20","avalia-red":"#fe0600","avalia-gray":"#bcc6cc","avalia-magenta":"#f91dff","avalia-green":"#27eb68","avalia-orange":"#ffa200","avalia-blue":"#00d2ff"};